import { render } from "./BrDollars.vue?vue&type=template&id=5d530922&scoped=true"
import script from "./BrDollars.vue?vue&type=script&lang=js"
export * from "./BrDollars.vue?vue&type=script&lang=js"

import "./BrDollars.vue?vue&type=style&index=0&id=5d530922&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d530922"]])

export default __exports__